<template>
  <div class="mypage-about-using-section">
    <about-using-data-list-parts :aboutUsingListItems="aboutUsingListItems" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import AboutUsingDataListParts from '@/components/MypageAboutUsingPage/MypageAboutUsingPane/parts/AboutUsingDataListParts.vue'

/**
 * マイページ: ご利用について データ セクション
 */
export default defineComponent({
  name: 'MypageAboutUsingSection',
  components: {
    AboutUsingDataListParts,
  },
  props: {
    /**
     * セクションタイトル
     */
    title: {
      type: String,
    },
    /**
     * データリスト
     */
    aboutUsingListItems: {
      type: Array,
      required: true,
    },
  },
})
</script>

<style lang="scss" scoped>
.mypage-about-using-section {
  width: 100%;
  margin-bottom: 24px;

  &__title {
    padding: 0 16px;
    margin-bottom: 8px;
    text-align: left;
    @include fontSetTextMedium(12);

    line-height: 1.67;
    color: $gray50;
  }
}
</style>
